"use client";

import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
export default function DelOlivarALaBotella() {
  const steps = [{
    id: 1,
    label: "Cultivo"
  }, {
    id: 2,
    label: "Cosecha"
  }, {
    id: 3,
    label: "Botella"
  }];
  return <section id="del-olivar-a-la-botella" className="relative min-h-screen bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1552070/img/deep_forest_olive_grove_background.png)] bg-cover bg-center bg-fixed section flex items-center">
      {}
      <div className="absolute inset-0 bg-primary-900/80" />
      
      <div className="relative container">
        <div className="mx-auto max-w-5xl">
          {}
          <h2 className="mb-16 text-center font-serif text-4xl font-medium !text-[hsl(48,100%,96%)] sm:text-5xl lg:text-6xl">
            El Arte de la Extracción en Frío
          </h2>

          <div className="mb-20">
            <AspectRatio ratio={16 / 9}>
              <div className="overflow-hidden rounded-lg border border-white/10">
            <iframe className="hero-img" width="100%" height="auto" style={{
                aspectRatio: '16 / 9'
              }} src="https://www.youtube.com/embed/Bz8mIWopNNY" title="El Arte de la Extracción en Frío" frameborder="0" allow="autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </AspectRatio>
          </div>

          <div className="mb-16 flex flex-col items-center justify-center gap-12 sm:flex-row sm:gap-8 lg:gap-16">
            {steps.map((step, i) => <div key={step.id} className="flex items-center gap-8 sm:gap-4 lg:gap-8" data-index={i}>
                <div className="flex flex-col items-center gap-4">
                  <div className="flex size-20 items-center justify-center rounded-full border border-accent/30 bg-white/5 backdrop-blur-sm transition-colors hover:bg-white/10">
                    <span className="font-serif text-3xl font-medium text-accent">{step.id}</span>
                  </div>
                  <p className="text-center text-sm font-medium tracking-[0.15em] uppercase text-secondary/90">
                    {step.label}
                  </p>
                </div>
                {i < steps.length - 1 && <div className="hidden h-px w-12 bg-accent/30 sm:block lg:w-20" />}
              </div>)}
          </div>

          <div className="flex justify-center">
            {}
            <Button asChild size="lg" className="btn">
              
            </Button>
          </div>
        </div>
      </div>
    </section>;
}